import React from "react";
import PropTypes from "prop-types";
import "./Container.css";

/**
 * Un conteneur qui limite la largeur, remplace la `div` de base. Permet le thème et les styles personnalisés.
 *
 * @param {object} children - Les éléments enfants à afficher.
 * @param {string} className - Les classes CSS additionnelles.
 * @param {object} style - Styles additionnels personnalisés.
 * @param {object} props - Propriétés additionnelles pour le conteneur.
 */
const Container = ({ children, className, ref, style = {}, ...props }) => {
  return (
    <div
      className={`Container ${className}`}
      ref={ref}
      style={{
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  props: PropTypes.object,
};

export default Container;
